export default {
  // gets a language code, a two letter language code optionally followed by country code e.g. 'en' or 'en-us'. See https://www.w3schools.com/tags/ref_language_codes.asp and
  // https://www.w3schools.com/tags/ref_country_codes.asp
  // https://gist.github.com/wpsmith/7604842
  getLang() {
    return navigator.language || navigator.browserLanguage || (navigator.languages || ["en"]) [0]
  },

}
